// Игровые часы для освещения карты и города: Москва (UTC+3), со сдвигом VITE_MAP_CLOCK «ISO|час» для показов
// и ?hour=19.5 в адресе для проверки.
import { moscowHour } from '@sk/shared';

export const CLOCK_SHIFT = (() => {
  const v = import.meta.env.VITE_MAP_CLOCK as string | undefined;
  if (!v) return 0;
  const [iso, hh] = v.split('|');
  const t = Date.parse(iso ?? '');
  const h = Number(hh);
  if (!Number.isFinite(t) || !Number.isFinite(h)) return 0;
  return (((h - moscowHour(t)) % 24) + 24) % 24;
})();

/** Час из адреса (?hour=19.5) или null. */
export const forcedHour = (() => {
  try {
    const q = new URLSearchParams(window.location.search);
    const h = Number(q.get('hour'));
    return q.has('hour') && Number.isFinite(h) ? h : null;
  } catch {
    return null;
  }
})();

/** Текущий игровой час (дробный). */
export function gameHour(nowMs = Date.now()): number {
  return forcedHour ?? (moscowHour(nowMs) + CLOCK_SHIFT) % 24;
}
